import React, { useState } from 'react';
import 'react-phone-number-input/style.css';
import PhoneInput from 'react-phone-number-input';
// import { useTranslation } from 'react-i18next';

const PhoneNumberInput = () => {
  const [value, setValue] = useState();
    // const { t } = useTranslation();
  

  return (
    <div>
      <PhoneInput
        placeholder='Nömrəni daxil edin'
        className="phone-input border border-[2px] p-[16px] bg-main rounded-[12px] outline-none text-white border-purple"
        value={value}
        onChange={setValue}
        defaultCountry="AZ"
      />
    </div>
  );
};

export default PhoneNumberInput;
